import styled from "styled-components";

export const Container = styled.div`
max-width: 375px;
display: flex;
border-radius: 15px;
flex-direction:column;
background-color: #fff;


`

export const ImgContainer = styled.div`
padding: 20px;
`

export const Image = styled.img`
width: 100%;
// height: 100%;
border-radius: 15px;
object-fit: contain;
`

export const Content = styled.div`
padding: 24px;
`

export const Title = styled.h2`
opacity 0.8;
font-weight: 700;
text-align: center;
`

export const Text = styled.p`
opacity: 0.5;
margin-top: 10px;
text-align: center;
`